"use client";

import React, { useState } from 'react';
import './SegmentsAccordion.css';

interface SegmentItem {
    name: string;
    children?: SegmentItem[];
}

interface SegmentCategory {
    title: string;
    items: SegmentItem[];
}

interface SegmentsAccordionProps {
    segments: SegmentCategory[];
}

const SegmentsAccordion: React.FC<SegmentsAccordionProps> = ({ segments }) => {
    const [openSections, setOpenSections] = useState<Set<number>>(new Set());

    const toggleSection = (index: number) => {
        const newOpenSections = new Set(openSections);
        if (newOpenSections.has(index)) {
            newOpenSections.delete(index);
        } else {
            newOpenSections.add(index);
        }
        setOpenSections(newOpenSections);
    };

    const renderSegmentItems = (items: SegmentItem[], level: number = 0) => {
        return (
            <ul className={`segment-list level-${level}`}>
                {items.map((item, idx) => (
                    <li key={idx} className="segment-item">
                        {item.name}
                        {item.children && item.children.length > 0 && renderSegmentItems(item.children, level + 1)}
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <div className="segments-accordion">
            {segments.map((segment, index) => (
                <div key={index} className="accordion-section">
                    <div
                        className={`accordion-header ${openSections.has(index) ? 'open' : ''}`}
                        onClick={() => toggleSection(index)}
                    >
                        <span className="toggle-icon">{openSections.has(index) ? '−' : '+'}</span>
                        <h3>{segment.title}</h3>
                    </div>
                    {openSections.has(index) && (
                        <div className="accordion-content">
                            {renderSegmentItems(segment.items)}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default SegmentsAccordion;
